import { Component } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { IGetEpisodesOfCare } from 'src/app/interfaces/IGetEpisodesOfCare';
import { EpisodeOfCareService } from 'src/app/services/episodeOfCare.service';
import { VisitExpandComponent } from '../visit-expand/visit-expand.component';

@Component({
  selector: 'app-active-eoc',
  templateUrl: './active-eoc.component.html',
  styleUrls: ['./active-eoc.component.css'],
  standalone: false,
})
export class ActiveEocComponent {
  public expandComp = VisitExpandComponent;

  private destroy$ = new Subject<void>();

  isLoading = false;
  episodesOfCare: IGetEpisodesOfCare[] = [];

  constructor(private readonly eocService: EpisodeOfCareService) {}

  ngOnInit() {
    this.eocService.activeEocLoadingSub
      .pipe(takeUntil(this.destroy$))
      .subscribe((data: boolean) => {
        this.isLoading = data;
      });

    this.eocService.activeEocDataSub
      .pipe(takeUntil(this.destroy$))
      .subscribe((data: IGetEpisodesOfCare[]) => {
        this.episodesOfCare = data;
      });

    this.eocService.getActiveData();
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
